import {TOption} from './TOption'

export const INVOICE_STATUS: TOption[] = [
  {value: '0', label: 'Belum Dikonfirmasi'},
  {value: '1', label: 'Telah Dikonfirmasi'},
  {value: '2', label: 'Menunggu Update SAP'},
  {value: '13', label: 'SAP Error'},
]
